// ===========================================
// ROOT REDUCER
// ===========================================

import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from '@/features/auth/store/authSlice';
import { uiReducer } from './slices/uiSlice';
import { appReducer } from './slices/appSlice';
import { preferencesReducer } from './slices/preferencesSlice';
import { adminAuthReducer } from './slices/adminAuthSlice';
import { adminUiReducer } from './slices/adminUiSlice';

/**
 * Combined root reducer
 * Includes both public and admin reducers
 */
export const rootReducer = combineReducers({
  // Public site reducers
  auth: authReducer,
  ui: uiReducer,
  app: appReducer,
  preferences: preferencesReducer,
  // Admin dashboard reducers
  adminAuth: adminAuthReducer,
  adminUi: adminUiReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
